export class AnalyticsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDashboards() {
    return this.#http.get('/analytics/dashboards');
  }

  async getDashboardsByUserId(userId) {
    return this.#http.get(`/analytics/users/${userId}/dashboards`);
  }

  async getDashboardEmbedLinkByDashboardId(dashboardId) {
    return this.#http.post(`/analytics/dashboards/${dashboardId}/embed-link`);
  }

  async setSelectedDashboards(body) {
    return this.#http.put(`/analytics/dashboards/roles-access/${body.roleId}`, body);
  }

  async getReports() {
    return this.#http.get('/analytics/reports');
  }

  async updateAccessToReports({ roleId, ...body }) {
    return this.#http.put(`/analytics/reports/roles/${roleId}`, body);
  }

  async getReportsByUserId(userId) {
    return this.#http.get(`/analytics/users/${userId}/reports`);
  }

  async getReportEmbedLinkByReportId(reportId) {
    return this.#http.post(`/analytics/reports/${reportId}/embed-link`);
  }

  async getAdminReportsEmbedLink() {
    return this.#http.post(`/analytics/reports/admin/embed-link`);
  }

  async setSelectedReports(body) {
    return this.#http.put(`/analytics/reports/roles-access/${body.roleId}`, body);
  }

  async getAdminEmbedLink() {
    return this.#http.post('/analytics/admin/embed-link');
  }
}
